import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_08283616 from 'nuxt_plugin_plugin_08283616' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_bootstrapvue_12f4445b from 'nuxt_plugin_bootstrapvue_12f4445b' // Source: ./bootstrap-vue.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_d55bcc58 from 'nuxt_plugin_cookieuniversalnuxt_d55bcc58' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_axios_2e0a522c from 'nuxt_plugin_axios_2e0a522c' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_serviceauthssrserver_069da9a9 from 'nuxt_plugin_serviceauthssrserver_069da9a9' // Source: ./firebase/service.auth.ssr-server.js (mode: 'server')
import nuxt_plugin_index_02de96e2 from 'nuxt_plugin_index_02de96e2' // Source: ./firebase/index.js (mode: 'all')
import nuxt_plugin_st_170fd156 from 'nuxt_plugin_st_170fd156' // Source: ../plugins/st (mode: 'client')
import nuxt_plugin_notifier_937d88cc from 'nuxt_plugin_notifier_937d88cc' // Source: ../plugins/notifier (mode: 'all')
import nuxt_plugin_snackbar_68026af9 from 'nuxt_plugin_snackbar_68026af9' // Source: ../plugins/snackbar (mode: 'all')
import nuxt_plugin_tracking_240dd56c from 'nuxt_plugin_tracking_240dd56c' // Source: ../plugins/tracking.js (mode: 'client')
import nuxt_plugin_disablelogs_3f94e71d from 'nuxt_plugin_disablelogs_3f94e71d' // Source: ../plugins/disable_logs.js (mode: 'client')
import nuxt_plugin_axios_2228ef02 from 'nuxt_plugin_axios_2228ef02' // Source: ../plugins/axios (mode: 'all')
import nuxt_plugin_headdata_0991aea2 from 'nuxt_plugin_headdata_0991aea2' // Source: ../plugins/head_data.js (mode: 'all')
import nuxt_plugin_alttexts_03bad51b from 'nuxt_plugin_alttexts_03bad51b' // Source: ../plugins/alt_texts.js (mode: 'all')
import nuxt_plugin_normalize_06376884 from 'nuxt_plugin_normalize_06376884' // Source: ../plugins/normalize.js (mode: 'all')
import nuxt_plugin_visibilityObserver_773c810a from 'nuxt_plugin_visibilityObserver_773c810a' // Source: ../plugins/visibilityObserver.js (mode: 'all')
import nuxt_plugin_scrolltoelement_2dc0307e from 'nuxt_plugin_scrolltoelement_2dc0307e' // Source: ../plugins/scroll_to_element.js (mode: 'all')
import nuxt_plugin_inviewport_24d7632a from 'nuxt_plugin_inviewport_24d7632a' // Source: ../plugins/in_viewport.js (mode: 'client')
import nuxt_plugin_googlemaps_431c8eee from 'nuxt_plugin_googlemaps_431c8eee' // Source: ../plugins/google_maps.js (mode: 'all')
import nuxt_plugin_numberCounter_4ad71098 from 'nuxt_plugin_numberCounter_4ad71098' // Source: ../plugins/numberCounter.js (mode: 'client')
import nuxt_plugin_fancybox_26e051e1 from 'nuxt_plugin_fancybox_26e051e1' // Source: ../plugins/fancybox.js (mode: 'client')
import nuxt_plugin_slider_71214602 from 'nuxt_plugin_slider_71214602' // Source: ../plugins/slider.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Digitl GmbH","htmlAttrs":{"lang":"en"},"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":""},{"name":"format-detection","content":"telephone=no"},{"name":"apple-mobile-web-app-title","content":"Digitl GmbH"},{"name":"application-name","content":"Digitl GmbH"},{"name":"msapplication-TileColor","content":"#174f78"},{"name":"theme-color","content":"#174f78"}],"link":[{"rel":"preload","as":"image","href":"\u002Ficons\u002Fimage-loader.svg"},{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon\u002Ffavicon.ico"},{"rel":"apple-touch-icon","sizes":"180x180","href":"\u002Ffavicon\u002Fapple-touch-icon.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"32x32","href":"\u002Ffavicon\u002Ffavicon-32x32.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"16x16","href":"\u002Ffavicon\u002Ffavicon-16x16.png"},{"rel":"manifest","href":"\u002Ffavicon\u002Fsite.webmanifest","crossorigin":"use-credentials"},{"rel":"mask-icon","href":"\u002Ffavicon\u002Fsafari-pinned-tab.svg","color":"#174f78"}],"script":[{"id":"usercentrics-cmp","src":"https:\u002F\u002Fapp.usercentrics.eu\u002Fbrowser-ui\u002Flatest\u002Floader.js","data-version":"","data-settings-id":"mibbPswOY5k6z_","async":true}],"style":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      errPageReady: false,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        nuxt.errPageReady = false
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_08283616 === 'function') {
    await nuxt_plugin_plugin_08283616(app.context, inject)
  }

  if (typeof nuxt_plugin_bootstrapvue_12f4445b === 'function') {
    await nuxt_plugin_bootstrapvue_12f4445b(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_d55bcc58 === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_d55bcc58(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_2e0a522c === 'function') {
    await nuxt_plugin_axios_2e0a522c(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_serviceauthssrserver_069da9a9 === 'function') {
    await nuxt_plugin_serviceauthssrserver_069da9a9(app.context, inject)
  }

  if (typeof nuxt_plugin_index_02de96e2 === 'function') {
    await nuxt_plugin_index_02de96e2(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_st_170fd156 === 'function') {
    await nuxt_plugin_st_170fd156(app.context, inject)
  }

  if (typeof nuxt_plugin_notifier_937d88cc === 'function') {
    await nuxt_plugin_notifier_937d88cc(app.context, inject)
  }

  if (typeof nuxt_plugin_snackbar_68026af9 === 'function') {
    await nuxt_plugin_snackbar_68026af9(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_tracking_240dd56c === 'function') {
    await nuxt_plugin_tracking_240dd56c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_disablelogs_3f94e71d === 'function') {
    await nuxt_plugin_disablelogs_3f94e71d(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_2228ef02 === 'function') {
    await nuxt_plugin_axios_2228ef02(app.context, inject)
  }

  if (typeof nuxt_plugin_headdata_0991aea2 === 'function') {
    await nuxt_plugin_headdata_0991aea2(app.context, inject)
  }

  if (typeof nuxt_plugin_alttexts_03bad51b === 'function') {
    await nuxt_plugin_alttexts_03bad51b(app.context, inject)
  }

  if (typeof nuxt_plugin_normalize_06376884 === 'function') {
    await nuxt_plugin_normalize_06376884(app.context, inject)
  }

  if (typeof nuxt_plugin_visibilityObserver_773c810a === 'function') {
    await nuxt_plugin_visibilityObserver_773c810a(app.context, inject)
  }

  if (typeof nuxt_plugin_scrolltoelement_2dc0307e === 'function') {
    await nuxt_plugin_scrolltoelement_2dc0307e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_inviewport_24d7632a === 'function') {
    await nuxt_plugin_inviewport_24d7632a(app.context, inject)
  }

  if (typeof nuxt_plugin_googlemaps_431c8eee === 'function') {
    await nuxt_plugin_googlemaps_431c8eee(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_numberCounter_4ad71098 === 'function') {
    await nuxt_plugin_numberCounter_4ad71098(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_fancybox_26e051e1 === 'function') {
    await nuxt_plugin_fancybox_26e051e1(app.context, inject)
  }

  if (typeof nuxt_plugin_slider_71214602 === 'function') {
    await nuxt_plugin_slider_71214602(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
